<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iUUTnb/tc-custom/scover.jpg?1684514748514" alt="This image is the cover for the book Home for Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home for Christmas
      </h1>
      <p class="bookDescription body article font2">
        <p>Connell and Spence met on the Savannah riverwalk, drawn together by Spence's music and the sudden passion that flared between them. But when Connell has to return to England, rather than wearing itself out as long-distance relationships often do, their attraction only grows stronger. Facing the holidays alone, Connell decides there's only one place he wants to be for Christmas--with Spence.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicki Bennett
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c0f2888